import * as Reducers from './package-users.reducer';
import * as MetaReducers from './package-users.metareducer';

export const PackageUsersReducers = { 
    Reducers,
    MetaReducers
};
